import { useExperiments } from '@wix/fe-essentials-standalone';

export const useSpec = (key: string) => {
  const { experiments } = useExperiments({ readOnly: true });
  return experiments.get(key) === 'true' ? true : false;
};
